var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.47026 5.99904C4.72977 5.73953 5.15046 5.7393 5.41026 5.99853L7.64683 8.23023C7.84201 8.42498 8.15799 8.42498 8.35317 8.23023L10.5897 5.99853C10.8495 5.7393 11.2702 5.73953 11.5297 5.99904V5.99904C11.7895 6.25876 11.7895 6.67984 11.5297 6.93955L8.70711 9.76219C8.31658 10.1527 7.68342 10.1527 7.29289 9.76219L4.47026 6.93955C4.21054 6.67984 4.21054 6.25876 4.47026 5.99904V5.99904Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.800afe5cfd00433205ea0779ff48d4da.svg";
export { ForwardRef as ReactComponent };